/**
 * Deterministic avatar helpers — derive initials and a stable color from a
 * user's name + email so two users with the same first two letters still get
 * visually distinct avatars.
 */

function hashString(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) + str.charCodeAt(i);
    h = h | 0; // force 32-bit signed
  }
  return Math.abs(h);
}

export function getAvatarInitials(name) {
  if (name == null) return '??';
  const cleaned = String(name).trim();
  if (cleaned.length === 0) return '??';
  // split on common separators; if multiple parts, take first letter of two
  const parts = cleaned.split(/[\s._\-@+]+/).filter(p => p.length > 0);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return cleaned.slice(0, 2).toUpperCase();
}

/**
 * Returns css color values that read well against both light and dark
 * surfaces. Background is a low-alpha tint, foreground is a saturated mid-
 * lightness color, border is a slightly stronger tint.
 */
export function getAvatarColors(name, email) {
  const seed = (String(name || '') + '|' + String(email || '')).toLowerCase();
  if (seed === '|') {
    return {
      bg:     'var(--panel-3)',
      fg:     'var(--fg-2)',
      border: 'var(--line)',
    };
  }
  const hue = hashString(seed) % 360;
  return {
    bg:     `hsla(${hue}, 70%, 55%, 0.18)`,
    fg:     `hsl(${hue}, 70%, 60%)`,
    border: `hsla(${hue}, 70%, 55%, 0.45)`,
  };
}
